/*
Poornima 09/19/2022 2701251212 Fixed GAL-127,132,73,60,104 bugs
Sohel 01/30/2023 2701251212 added Record Separator LookUP
*/
import {createSlice} from '@reduxjs/toolkit';
import {DATE_FORMAT, FIELD_SEPERATOR, FILE_TYPE, PHASE, RECORD_TYPE, RECORD_SEPERATOR, DM_FIELD_SEPERATOR} from '../../../constants/Lookup';
import download from '../../../util/DownloadLink';
import {httpGet, httpPost} from '../../../util/Rest';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  addRecordFormatStatus: null,
  recordFormatData: {},
  listOfrecordFormatData: [],
  dropDownData: {},
  searchRecordFormatFieldData: {},
  userMetrix: '',
  addSuccessMsg: null,
  addRecordData: {},
  addRecordStatus: null,
  addEnableRecordStatus: null,
  addEnableRecordData: {},
  recordFormatUsageData: {},
  recordFormatRowData: {},
  allCodeAndDescriptions: [],
};

const slice = createSlice({
  name: 'addRecordFormat',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    postRecordFormatData: (state, action) => {
      state.addRecordFormatStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
      state.userMetrix = action.payload.response.userMetrix;
    },
    postRecordFormatAddData: (state, action) => {
      state.addRecordStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.addRecordData = action.payload.response.placeResponse;
      state.addSuccessMsg = action.payload.message;
      state.userMetrix = action.payload.response.userMetrix;
    },
    postEnableRecordFormatAddData: (state, action) => {
      state.addEnableRecordStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.addEnableRecordData = action.payload.response.placeResponse;
      state.addSuccessMsg = action.payload.message;
      state.userMetrix = action.payload.response.userMetrix;
    },
    getRecordFormatData: (state, action) => {
      state.recordFormatData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addRecordFormatStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getListOfRecordFormatData: (state, action) => {
      state.listOfrecordFormatData = [...state.listOfrecordFormatData, action.payload];
      state.isLoading = false;
      state.errorMsg = null;
      state.addRecordFormatStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    setRecordFormatSearchFieldData: (state, action) => {
      state.searchRecordFormatFieldData = action.payload;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    fetchAddSuccess: (state, action) => {
      state.addSuccessMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ? action.payload.data.message : '';
      state.isLoading = false;
    },
    setRecordFormatUsage: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.recordFormatUsageData = action.payload;
    },
    setRecordFormatRowData: (state, action) => {
      state.recordFormatRowData = action.payload;
    },
    resetStatus: (state, action) => {
      state.addRecordFormatStatus = null;
      state.isLoading = false;
      state.recordFormatData = {};
    },
    resetMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetFieldData: (state, action) => {
      state.searchRecordFormatFieldData = {};
    },
    resetRecordStatus: (state, action) => {
      state.addRecordStatus = null;
      state.addSuccessMsg = null;
    },
    resetEnableRecordStatus: (state, action) => {
      state.addEnableRecordStatus = null;
      state.addSuccessMsg = null;
    },
    resetRecordFormatData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.addRecordFormatStatus = null;
      state.recordFormatData = {};
      state.listOfrecordFormatData = [];
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetOverrideStatus: (state, action) => {
      state.userMetrix = '';
      state.addRecordStatus = null;
      state.addEnableRecordStatus = null;
    },
    resetUsageData: (state, action) => {
      state.recordFormatUsageData = {};
      state.recordFormatRowData = {};
    },
    getAllCodeAndDescriptions: (state, action) => {
      state.allCodeAndDescriptions = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  postRecordFormatData,
  getRecordFormatData,
  getListOfRecordFormatData,
  fetchSuccess,
  fetchError,
  resetMessage,
  resetStatus,
  resetFieldData,
  resetRecordFormatData,
  fetchDropDownData,
  setRecordFormatSearchFieldData,
  postRecordFormatAddData,
  fetchAddSuccess,
  resetRecordStatus,
  postEnableRecordFormatAddData,
  resetEnableRecordStatus,
  resetOverrideStatus,
  setRecordFormatUsage,
  resetUsageData,
  setRecordFormatRowData,
  getAllCodeAndDescriptions,
} = slice.actions;

export const postRecordFormat = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/save/recordformat`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          dispatch(postRecordFormatAddData(data));
          dispatch(postEnableRecordFormatAddData(data));
          dispatch(fetchAddSuccess(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postRecordFormatData(data));
          dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchRecordFormat = (recordFormatId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/get/recordformat/${recordFormatId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getRecordFormatData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchListOfRecordFormats = (recordFormatId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/get/recordformat/${recordFormatId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getListOfRecordFormatData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lookup/find/all/lookup`, {
      typeCode: [FIELD_SEPERATOR, DATE_FORMAT, FILE_TYPE, PHASE, RECORD_TYPE, RECORD_SEPERATOR, DM_FIELD_SEPERATOR],
    })
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchDropDownData(data.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const printRecordFormat = (payload, printData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`recordFormat/generateurlprintRecordFormat`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(printData));
          download(data.data);
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postPrintRecordFormat = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`recordFormat/print/recordformat`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(printRecordFormat({dockey: data?.message}, data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const fetchRecordFormatUsage = ({code, frameWorkType, rowData}) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/view/frameworkusages/${code}/${frameWorkType}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(setRecordFormatRowData(rowData));
          dispatch(setRecordFormatUsage(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};

export const handleRecordFormatSearchField = (details) => {
  return (dispatch) => {
    dispatch(setRecordFormatSearchFieldData(details));
  };
};

export const resettingFieldData = () => {
  return (dispatch) => {
    dispatch(resetFieldData());
  };
};

export const ResetAddRecord = () => {
  return (dispatch) => {
    dispatch(resetRecordStatus());
  };
};
export const ResetEnableAddRecord = () => {
  return (dispatch) => {
    dispatch(resetEnableRecordStatus());
  };
};
export const fetchAllCodeAndDescription = (data) => {
  return (dispatch) => {
    httpGet(`recordFormat/find/all/recordformatcodeanddescription`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllCodeAndDescriptions(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
